import React from "react";


function WorkPayment({items,title,subtitle}) {
  return (
    <div className="bg-white h-auto lg:py-[4.12rem] py-[2rem] lg:px-[5.69rem] md:px-[2rem] px-[1rem]">
      <div className="flex flex-col items-center justify-center text-center">
        <h2 className="text-[#000] lg:text-[3rem] md:text-[2.5rem] text-[2rem] font-[500] lg:leading-[3.375rem] md:leading-[3rem] leading-[2.5rem]">
         {title}
        </h2>
        <p className="mt-[1rem] text-[#000] lg:text-[1.125rem] md:text-[1rem] text-[0.9375rem] font-[400] lg:leading-[1.625rem] leading-[1.5rem] max-w-[90%] md:max-w-[70%]">
         {subtitle}
        </p>
      </div>

      <div className="lg:mt-[2.62rem] mt-[1rem] relative lg:min-h-[24rem] min-h-auto">
        {/* Dotted curved line - only between icons, doesn't extend past first/last */}
        <svg
          className="hidden lg:block absolute top-[7rem] left-[12.5%] w-[75%] h-[8rem] pointer-events-none"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 900 150"
          fill="none"
          preserveAspectRatio="none"
          style={{ zIndex: 0 }}
        >
          <path
            d="M0 75 Q 150 40, 300 75 T 600 75 T 900 75"
            stroke="#D1D1D1"
            strokeWidth="2"
            fill="none"
            strokeDasharray="8 8"
          />
        </svg>

        {/* Grid container */}
        <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 lg:gap-[2rem] md:gap-[3rem] gap-[2.5rem] relative">
          {items?.map((item, index) => {
            // Icon positions to sit on the curve - desktop only
            const iconTopPositions = [
              "2rem",   // 1 Prepare your list (higher)
              "3.5rem", // 2 Review & Approve
              "7rem",   // 3 Disburse Instantly (lower)
              "4rem",   // 4 Track & Reconcile
            ];

            return (
              <div
                key={index}
                className="flex flex-col items-center text-center relative lg:pt-[12rem] md:pt-0 pt-0"
              >
                {/* Icon - positioned on curve for desktop, centered above text for mobile */}
                <div
                  className="lg:absolute relative lg:w-[10rem] lg:h-[10rem] md:w-[9rem] md:h-[9rem] w-[8rem] h-[8rem] flex items-center justify-center md:mb-[2rem] mb-[1.5rem] lg:mb-0"
                  style={{
                    top: iconTopPositions[index],
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 1
                  }}
                >
                  <img
                    src={item?.svg}
                    alt={item?.svg}
                    className="max-w-full max-h-full object-contain drop-shadow-lg"
                  />
                </div>

                {/* Text content */}
                <div className="flex flex-col items-center">
                  <h3 className="text-[#1E191B] lg:text-[1.125rem] md:text-[1.125rem] text-[1rem] font-[600] lg:leading-[1.5rem] leading-[1.4rem] mb-[0.75rem]">
                    {item?.title}
                  </h3>
                  <p className="text-[#64607D] lg:text-[0.9375rem] md:text-[0.9375rem] text-[0.875rem] font-[400] lg:leading-[1.5rem] leading-[1.4rem] lg:max-w-[13rem] md:max-w-[14rem] max-w-[18rem]">
                    {item?.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
 

    </div>
  );
}

export default WorkPayment;
